export default __webpack_public_path__ + "static/media/SKS_Prescription.70d94ef8.svg";